import {
  styled,
  TableContainer as MuiTableContainer,
  TableContainerProps as MuiTableContainerProps,
} from "@mui/material";
import React from "react";
import { pxToRem } from "../../utils/fontSizeUtility";

type TableContainerProps = MuiTableContainerProps & {
  hasTotalRow: boolean;
  isBubbleTable: boolean;
};

export const TableContainer = styled(MuiTableContainer, {
  shouldForwardProp: (prop) => prop !== "hasTotalRow" && prop !== "isBubbleTable",
})<TableContainerProps>(({ theme, hasTotalRow, isBubbleTable }) => ({
  ".MuiTable-root": {
    backgroundColor: "inherit",
    caption: {
      captionSide: "top",
      color: "text.secondary",
      fontSize: pxToRem(15),
      fontWeight: 700,
      padding: `0 0 ${pxToRem(12)} 0`,
    },
  },
  "td, th": { padding: 0, border: 0 },
  ".MuiTableCell-head": {
    paddingBottom: pxToRem(24),
    fontWeight: isBubbleTable ? 400 : 700,
  },
  ".MuiTableRow-head": {
    th: {
      paddingRight: pxToRem(10),
    },
    "th:last-of-type": {
      paddingRight: 0,
    },
  },
  ".MuiTableCell-body": {
    paddingBottom: pxToRem(2),
  },
  ".MuiTableRow-root": {
    fontWeight: 400,
    th: {
      color: theme.palette.text.secondary,
      paddingRight: pxToRem(10),
      paddingTop: 0,
    },
    tr: {
      color: theme.palette.text.secondary,
    },
    td: {
      paddingRight: pxToRem(10),
      ...(isBubbleTable && {
        fontWeight: "600",
      }),
    },
    "td:last-of-type": {
      paddingRight: 0,
    },
    ...(isBubbleTable && {
      "td, th": {
        paddingBottom: pxToRem(7),
      },
    }),
  },
  ...(hasTotalRow && {
    ".MuiTableBody-root > .MuiTableRow-root": {
      "&:nth-last-of-type(2) th, &:nth-last-of-type(2) td": {
        paddingBottom: pxToRem(12),
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
      "&:last-child td, &:last-child th": {
        paddingTop: pxToRem(12),
      },
    },
  }),
})) as React.ComponentType<TableContainerProps>;
